import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { ContractorProfileService } from './contractor-profile.service';
import {
  EmployeePerformanceUpdatePayload,
  EmployeeSkillsUpdatePayload
} from '@app/shared/interfaces/contractor-profile';

const aboutMap: Record<string, string> = {
  'Email ID': 'email',
  'Location': 'city',
  'Total Experience': 'yearsOfExperience',
  'DOJ': 'joining'
};

const teamMap: Record<string, string> = {
  'LOB': 'lobName',
  'Reports To': 'reportingManager',
  'L3 Leader': 'l3Leader',
  'Project': 'projectName',
};

const performanceMap: Record<string, string> = {
  'Critical Resource': 'criticalResource',
  'Last Spot Award': 'lastSpotAward',
};

const skillsMap: Record<string, string> = {
  'Primary Skills': 'primarySkills',
  'Secondary Skills': 'secondarySkills',
  'Certifications': 'certifications',
};

function getFormValue(form: FormGroup, label: string): any {
  return form && form.contains(label) ? form.get(label)?.value : undefined;
}
function toIsoIfDate(val: any): string | undefined {
  if (!val || val === "N/A") return undefined;
  const d = new Date(val);
  if (isNaN(d.getTime())) return undefined;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function submitEdit(
  form: FormGroup,
  contractorId: string,
  api: ContractorProfileService,
  fieldMap: Record<string, string>,
  apiMethod: keyof Pick<ContractorProfileService,
    'updateEmployeePerformance' |
    'updateEmployeeSkills'
  >,
  transformers: Record<string, (val: any) => any> = {}
): Observable<any> {
  const payload:
                EmployeePerformanceUpdatePayload |
                EmployeeSkillsUpdatePayload = { employeeId: contractorId };

  Object.entries(fieldMap).forEach(([label, apiField]) => {
    let value = getFormValue(form, label);
    if (value === "N/A") { value = null; }
    if (value !== undefined) {
      (payload as any)[apiField] = transformers[apiField] ?
        transformers[apiField](value) :
        value;
    }
  });

  return api[apiMethod](payload as any);
}

export function submitPerformanceEdit(
  form: FormGroup,
  contractorId: string,
  api: ContractorProfileService
): Observable<any> {
  return submitEdit(form, contractorId, api, performanceMap, 'updateEmployeePerformance', {
    lastSpotAward: (v) => toIsoIfDate(v) ?? v,
    awards: (v) => v === '' ? undefined : Number(v)
  });
}

export function submitSkillsEdit(
  form: FormGroup,
  contractorId: string,
  api: ContractorProfileService
): Observable<any> {
  return submitEdit(form, contractorId, api, skillsMap, 'updateEmployeeSkills');
}
